import React from 'react';
import p from '../../styles/renewal/OnePage.module.css';
import { REVIEWS, REVIEW_STATS } from './data';

/** 시안 #cases — 끊김 없는 마퀴를 위해 목록을 두 번 이어 붙인다. */
const LOOP = REVIEWS.concat(REVIEWS);

const Cases = () => (
  <>
    <section className={`${p.section} ${p.reveal}`}>
      <div className={p.headRow}>
        <div>
          <div className={p.badge}>REVIEW</div>
          <h2 className={p.title}>실제 이용 사업자들의 이야기</h2>
        </div>
      </div>

      <div className={p.marquee}>
        <div className={p.track}>
          {LOOP.map((rv, i) => (
            <div className={`${p.card} ${p.reviewCard}`} key={`${rv.name}-${i}`} aria-hidden={i >= REVIEWS.length}>
              <div className={p.reviewTop}>
                <div className={p.reviewAvatar} aria-hidden="true">
                  {rv.initial}
                </div>
                <div>
                  <div className={p.reviewName}>{rv.name}</div>
                  <div className={p.reviewMeta}>{rv.meta}</div>
                </div>
              </div>

              <p className={p.reviewQuote}>{rv.quote}</p>

              <div className={p.reviewFoot}>
                <div>
                  <div className={p.reviewFootLabel}>이용 서비스</div>
                  <div className={p.reviewFootValue}>{rv.svc}</div>
                </div>
                <div>
                  <div className={p.reviewFootLabel}>{rv.metricLabel}</div>
                  <div className={p.reviewFootValue}>{rv.metric}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={p.fadeLeft} aria-hidden="true" />
        <div className={p.fadeRight} aria-hidden="true" />
      </div>
    </section>

    <section className={`${p.section} ${p.sectionTight} ${p.reveal}`}>
      <div className={p.gridAutoSm}>
        {REVIEW_STATS.map((stat) => (
          <div className={p.scoreCard} key={stat.label}>
            <div className={p.scoreValue}>{stat.value}</div>
            <div className={p.scoreLabel}>{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  </>
);

export default Cases;
